import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { UploadInput, UploadPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = UploadInput;
type TData = UploadPayload;

export const useTranslationMemoryUpload = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation translationMemoryUpload($input: UploadInput!) {
      translationMemoryUpload(input: $input) {
        success
        errors
        errorCode
        uid
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
